import React from 'react';
import { Container } from '@mui/material';
import PageUnderConstruction from '../components/UnderConstruction/PageUnderConstruction';

function Projects() {
	return (
		<Container>
			<PageUnderConstruction />
		</Container>
	);
}

export default Projects;
